import React from 'react';
import TextBlock from 'components/common/helpMeDecide/TextBlock';
import withCriteria from 'components/common/helpMeDecide/withCriteria';
import { Guideline, RadioGroup } from '@insurancemenu/imenu-components-lib';
import { createStyles } from 'components/common/helpMeDecide/commonCriteriaStyles';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';

const MedicalCriteria1 = observer((): JSX.Element => {
  const classes = createStyles();

  // Mobx store
  const {
    browsingFilterStore: { onBrowsingCriteriaChange, getBrowsingCriteriaValue },
  } = useRootStore();
  const bcName = 'insuranceType_FILTER';

  // Values for radio buttons group
  const radioButtons = [
    {
      id: 'PPO',
      label: 'Willing to pay extra for the widest network or choice of doctors',
      value: 'PPO',
    },
    {
      id: 'HMO',
      label: 'Show me lower priced plans with smaller network of doctors',
      value: 'HMO',
    },
  ];

  return (
    <div>
      <TextBlock
        title="Insurance Type"
        subtitle="Do you want to prioritize the widest possible network or would you consider a smaller network of doctors to lower costs?"
      />
      <RadioGroup
        label=""
        value={getBrowsingCriteriaValue(bcName)}
        radioButtons={radioButtons}
        className={classes.radioButtonGroup}
        onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
          onBrowsingCriteriaChange(bcName, e.target.value);
        }}
      />
      <Guideline
        simpleStyles
        labels={{
          opened: 'Learn More About Plan Types',
          closed: 'Learn More About Plan Types',
        }}
        className={classes.guidelineWrapper}
        content={
          <div className={classes.guidelineMultiSectionContent}>
            <div>
              <b>PPO (Preferred Provider Organization):</b>
              <ul className={classes.guidelineList}>
                <li className={classes.guidelineItem}>
                  Includes a large network of participating providers that an individual can see with or without a
                  referral
                </li>
                <li className={classes.guidelineItem}>
                  Provides coverage for out of network providers, but visiting these providers will be higher cost
                </li>
                <li className={classes.guidelineItem}>No need to choose a Primary Care Physician</li>
                <li className={classes.guidelineItem}>
                  Generally, the additional provider access comes with a higher cost to employers and employees
                </li>
              </ul>
            </div>
            <div>
              <span>
                <b>HMO:</b>
              </span>
              <ul className={classes.guidelineList}>
                <li className={classes.guidelineItem}>
                  An individual must use in-network physicians – there is no out-of-network benefits
                </li>
                <li className={classes.guidelineItem}>
                  Individuals often must receive referrals from their primary care physician to see specialists
                </li>
                <li className={classes.guidelineItem}>
                  The network tends to be smaller and often have smaller service areas
                </li>
                <li className={classes.guidelineItem}>
                  Generally, HMO plans are lower cost than their PPO counterparts
                </li>
              </ul>
            </div>
          </div>
        }
      />
    </div>
  );
});

export default withCriteria(MedicalCriteria1, 1);
